(function ($) { 

    Drupal.behaviors.publicProfile = {

        attach: function (context) {
            
            $(".user_artistic_upload.formField-achievements").each(function(){

                var filePath = $(this).children(".user_artistic_upload_data").attr("data-work-file");
                var fileExt = filePath.split(".").pop().toLowerCase(); //.substring(0,3);
                if(fileExt.indexOf("?") >= 0){
                    fileExt = fileExt.substring(0,fileExt.indexOf("?"));
                }

                $(this).children(".formField-photoLoader-photo").removeClass("fallback");
                $(this).children(".formField-photoLoader-photo").html("");

                if(fileExt != "jpg" && fileExt != "png" && fileExt != "jpeg"){
                    var fallback = $(".formField-photoLoader-photo").attr("data-fallback-image");
                    $(this).children(".formField-photoLoader-photo").css("background-image", "url('" + fallback + "')");
                    $(".formField-photoLoader-photo").addClass("fallback");
                    $(this).children(".formField-photoLoader-photo").html(fileExt);							
                }
                
                $(this).children(".formField-photoLoader-photo").attr("href", filePath);
            });

            $(".publicProfile", context).each(function (index){    

                $("#user_artistic_works_create").on('show.bs.modal', function (e) {
                    initProfileArtworksValidation($(this));
                });			
                $("#user_artistic_works_create").on('hidden.bs.modal', function (e) {
                    Drupal.behaviors.formValidation.resetUploadField($(this));                    
                });			

                $("#group_artistic_works_create").on('show.bs.modal', function (e) {
                    initProfileArtworksValidation($(this));
                });						
                $("#group_artistic_works_create").on('hidden.bs.modal', function (e) {
                    Drupal.behaviors.formValidation.resetUploadField($(this));
                });						

            });

            function initProfileArtworksValidation(modal){

                modal.find(".profileArtisticSubmitButton").click(function(event){
                    $(".preloader").show();

                    //validate form...
                    var validationResult = Drupal.behaviors.formValidation.validateFields($(this).closest(".modal-content"), true);
                    if(validationResult){

                        //remove input filed
                        $("#user_work_file").remove();

                        //submit form...
                        return true;
                    }
                    else{
                        event.preventDefault();
                        return false;
                        $(".preloader").hide();
                    }
                    
                });
            }
        }
    }

})(jQuery);